module.exports = __webpack_public_path__ + "static/media/pricing-hero-top-mob.dee3a4e4.png";